export default {
	sectionTitle: {
		en: 'Tickets'
	},
	ticketBuyButton: {
		en: 'Buy now'
	},
	ticketHighlightedBuyButton: {
		en: 'Buy now'
	},
	ticketHorizontalBuyButton: {
		en: 'Buy now'
	},
	ticketHighlightedHorizontalBuyButton: {
		en: 'Buy now'
	},
	ticketFinalButton: {
		en: 'Register'
	},
  ticketHighlighted: {
		en: 'Most Popular'
	},
  ticketTax: {
		en: '+TAX'
	},
  ticketHighlightedTax: {
		en: '+TAX'
	},
  ticketSoldOut: {
    en: 'Sold Out'
  }
};
